<script>
  import AuthService from "./../authService.js";
  import ComplaintFormService from "./../complaintFormService";
  import FormGroup from "./FormGroup.svelte";
  import { localisedRoute, navigateTo } from "svelte-router-spa";
  import * as animateScroll from "svelte-scrollto";
  import { Circle3 } from "svelte-loading-spinners";
  import { beforeUpdate } from "svelte";
  import { stringify } from "query-string";

  export let params;
  export let currentRoute;
  export let client;
  export let type;

  console.log('cliente: ', client)

  let request;
  let complaintForm;

  var inflators = { inflators: "groups,questions" };
  var filters = { filters: "type:" + type };
  let questions = [];
  let password = "";
  let password_repeat = "";
  let first_name = "";
  let last_name = "";
  let email = "";
  let createAccount = false;
  let agreeTerms = false;
  let questionErrors = null;
  let accountError = null;
  let button_save_label = 'Enviar';

  import { getNotificationsContext } from "svelte-notifications";

  const { addNotification } = getNotificationsContext();

  function addInitialData(questionData) {
    questions.push(questionData);
  }

  function modifyData(data) {
    const questionIndex = questions.findIndex(
      element => element.question_uuid == data.question_uuid
    );

    let newQuestions = [...questions];

    if ("value" in newQuestions[questionIndex]) {
      newQuestions[questionIndex].value = data.value;
      questions = newQuestions;
    } else if ("files" in newQuestions[questionIndex]) {
      newQuestions[questionIndex].files = data.files;
      questions = newQuestions;
    }
  }

  function handleSubmit(event) {

    if (!agreeTerms)
    {
      alert('ERROR:\n\nPara continuar, debes estar de acuerdo con los términos y condiciones.')
    }
    else
    {
      const data = {
        questions: questions,
        password: password,
        password_repeat: password_repeat
      };

      if (createAccount)
      {
        data.account = {
          first_name: first_name,
          last_name: last_name,
          email: email
        };
      }

      postForm(data);
    }
  }

  function copyData(event)
  {
    first_name = document.getElementById('Nombre').value
    last_name = document.getElementById('Apellido').value
    email = document.getElementById('EMail').value
  }

  const fetchData = async () => {
    const request = await fetch(
      `${__myapp.env.API_URL}client/${client.uuid}/complaint-form?${stringify(filters)}&${stringify(inflators)}`
    );
    complaintForm = await request.json();

    //console.log('complaint Form: ', complaintForm.data.complaint_form.type);

    return complaintForm;
  };

  async function postForm(data) {

    button_save_label = 'Guardando... Favor espere!'

    const response = await ComplaintFormService.registerResponse(
      complaintForm.data.complaint_form.uuid,
      data
    );

    button_save_label = 'Guardar'

    if (!response.success)
    {
      if (response.body.code === 5)
      {
        AuthService.logout();
      }
    }
    else
    {
      if (response.body.question_errors || response.body.account_error)
      {
        addNotification({
          id: new Date().getTime(),
          text: "Atención",
          description: "Se han encontrado errores en el formulario",
          removeAfter: 4000,
          position: "bottom-right",
          type: "danger"
        });
        questionErrors = response.body.question_errors;
        accountError = response.body.account_error;
      }
      else
      {
        addNotification({
          id: new Date().getTime(),
          text: "Atención",
          description: "Se ha registrado correctamente el formulario",
          removeAfter: 4000,
          position: "bottom-right",
          type: "success"
        });

        if (AuthService.isAuthenticated())
        {
          navigateTo("/denuncias");
        }
        else
        {
          navigateTo("/denuncia-exito/" + response.body.data.id);
        }
      }
    }
  }

  $: if (client) {
    questions = [];
    request = fetchData();
  }

  $: if (questionErrors && questionErrors.length > 0) {
    animateScroll.scrollToTop({ offset: 230 });
  }
</script>

<h4 id="selected-client" class="mb-4">Cliente seleccionado: {client.company}</h4>
{#await request}
  <div class="d-flex justify-content-center">
    <Circle3
      size="60"
      ballTopLeft="#4843d2"
      ballTopRight="#4843d2"
      ballBottomLeft="#4843d2"
      ballBottomRight="#4843d2"
      unit="px" />
  </div>
{:then complaintForm}
  <div class="py-3">
    <form id="contact-form">
      {#each complaintForm.data.complaint_form.groups as group, i}
        <FormGroup
          {group}
          {addInitialData}
          {modifyData}
          errors={questionErrors} />
      {/each}

      <div class="p-4 bg-white">
        {#if !AuthService.isAuthenticated()}
          <p class="text-4">
            Para realizar un seguimiento de la <b>{complaintForm.data.complaint_form.type === 'free_assistance' ? 'Asistencia legal solicitada' : 'denuncia'}</b>, cree una contraseña.
          </p>
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <h3 class="text-3 mb-3">Crear contraseña</h3>
              <div class="form-group">
                <input
                  type="password"
                  name="name"
                  class={`form-control inputs ${accountError && accountError.password ? 'is-invalid' : ''}`}
                  bind:value={password} />
                <div class="invalid-feedback">
                  {accountError && accountError.password}
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <h3 class="text-3 mb-3">Confirmar contraseña</h3>
              <div class="form-group">
                <input
                  type="password"
                  name="name"
                  class={`form-control inputs ${accountError && accountError.password_repeat ? 'is-invalid' : ''}`}
                  bind:value={password_repeat} />
                <div class="invalid-feedback">
                  {accountError && accountError.password_repeat}
                </div>
              </div>
            </div>


            <div class="col-md-12 col-lg-12">
              <div style="text-align:justify;">
                <b><u>Por favor no olvide anotarla.</u></b>
                Con esta <span style="color:red;">contraseña</span> y el <span style="color:red;">número de caso</span> que le proporcionaremos una vez concluya este registro, podrá hacer seguimiento al estado de su solicitud y comunicarse vía <b>chat</b> con el abogado que le asignaremos.<br><br>
                Si lo desea, puede ingresar sus datos personales <u>(mantenemos estricta confidencialidad de los datos)</u> e <b>iniciar sesión</b> en nuestro portal con su <span style="color:red;">email</span> y <span style="color:red;">contraseña</span> creada anteriormente para hacer seguimiento de su(s) caso(s).
              </div>
            </div>

          </div>
          <div class="chiller_cb my-3">
            <input
              id="new-account-check"
              type="checkbox"
              bind:checked={createAccount}
              on:click={copyData} />
            <label for="new-account-check">
              Ingresar mis datos para realizar seguimiento <b>{complaintForm.data.complaint_form.type === 'free_assistance' ? 'a mi solicitud de Asistencia legal' : 'a denuncias'}</b>.
            </label>
            <span />
          </div>

          {#if createAccount}
            <div class="row">
              <div class="col-md-4 col-lg-4">
                <h3 class="text-3 mb-3">Nombre</h3>
                <div class="form-group">
                  <input
                    type="text"
                    name="name"
                    class={`form-control inputs ${accountError && accountError['account.first_name'] ? 'is-invalid' : ''}`}
                    bind:value={first_name} />
                  <div class="invalid-feedback">
                    {accountError && accountError['account.first_name']}
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-4">
                <h3 class="text-3 mb-3">Apellido</h3>
                <div class="form-group">
                  <input
                    type="text"
                    name="name"
                    class={`form-control inputs ${accountError && accountError['account.last_name'] ? 'is-invalid' : ''}`}
                    bind:value={last_name} />
                  <div class="invalid-feedback">
                    {accountError && accountError['account.last_name']}
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-4">
                <h3 class="text-3 mb-3">Email</h3>
                <div class="form-group">
                  <input
                    type="email"
                    name="name"
                    class={`form-control inputs ${accountError && accountError['account.email'] ? 'is-invalid' : ''}`}
                    bind:value={email} />
                  <div class="invalid-feedback">
                    {accountError && accountError['account.email']}
                  </div>
                </div>
              </div>
            </div>
          {/if}
        {/if}

        <div class="chiller_cb my-3">
          <input
            id="agree-terms-check"
            type="checkbox"
            bind:checked={agreeTerms} />
          <label for="agree-terms-check">
            He leído y aceptado los <a href="/terms-conditions" target="_blank">Términos y Condiciones</a> para
            {complaintForm.data.complaint_form.type === 'free_assistance' ? 'solicitar asistencia legal gratuita.' : 'informar el ilícito o irregularidad detectada.'}
          </label>
          <span />
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6">
            <p class="text-center mt-4 mb-0">
              <button
                id="cancel-btn"
                class="btn btn-dark btn-block rounded-0 shadow-none
                justify-content-center"
                type="submit">
                Cancelar
              </button>
            </p>
          </div>
          <div class="col-md-6 col-lg-6">
            <p class="text-center mt-4 mb-0">
              <button
                id="submit-btn"
                class="btn btn-primary btn-block rounded-0 shadow-none
                justify-content-center"
                on:click={handleSubmit}
                type="button">
                {button_save_label}
              </button>
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
{:catch error}
  <h1>Este servicio no está contratado. Contáctenos si lo desea habilitar a contacto@fiscaliaprivada.cl.</h1>
{/await}
